import Vue from "vue";
import Vuex from "vuex";
import AuthModule from "./modules/Auth.module";
import UserModule from "./modules/User.module";
import ConfigModule from "./modules/Config.module";
import CompanyModule from "./modules/Company.module";
import GameModule from "./modules/Game.module";
import PlanModule from "./modules/Plan.module";
import TypeModule from "./modules/Type.module";
import GameQuestion from "./modules/GameQuestion.module";
import GameLogModule from "./modules/GameLog.module";
import OrganizationModule from "./modules/Organization.module";
import TagModule from "./modules/Tag.module";
import MediaModule from "src/packages/gallery/Media.module";
import CurrentOrg from "./modules/CurrentOrg.module";
import UpdateModule from "./modules/Update.module";
import QuestionModule from "root/packages/closeapp/QuestionsManager/assets/store/Question.module";
import ScoreModule from "./modules/Score.module";
import CategoryModule from "./modules/Category.module";

import InvitationModule from "./modules/Invitation.module";

Vue.use(Vuex);
const store = new Vuex.Store({
	state: {
		loading: false,
		userMenuOpen: false,
		snackbar: {
			show: false,
			message: "",
			color: "red",

		},
		env: window.__env_public,
	},
	modules: {
		AuthModule,
		UserModule,
		ConfigModule,
		CompanyModule,
		QuestionModule,
		GameModule,
		PlanModule,
		CurrentOrg,
		TypeModule,
		GameQuestion,
		GameLogModule,
		TagModule,
		OrganizationModule,
		UpdateModule,
		MediaModule,
		InvitationModule,
		ScoreModule,
		CategoryModule
	},
	mutations: {
		toggleUserMenu(state) {
			state.userMenuOpen = ! state.userMenuOpen;
		},
		closeUserMenu(state) {
			state.userMenuOpen = false;
		},
		SHOW_SNACKBAR(state, payload) {
			state.snackbar.show = true;
			state.snackbar.message = payload.message;
			state.snackbar.color = payload.color || "red"; // Default to red
		},
		HIDE_SNACKBAR(state) {
			state.snackbar.show = false;
			state.snackbar.message = "";
		},
	},
	getters: {
		isUserMenuOpen (state) {
			return state.userMenuOpen;
		}
	},
});
export default store;

export const config = function (key, value) {
	store.commit(ConfigModule.types.SET, { key, value });
};
window.cc = config;
